import { getHeaders, getMXIEndpoint } from "../../../helpers/endpoint";

export const REQUEST_MXI_UPDATE_PLAYER = 'REQUEST_MXI_UPDATE_PLAYER';
export const SUCCESS_MXI_UPDATE_PLAYER = 'SUCCESS_MXI_UPDATE_PLAYER';
export const FAIL_MXI_UPDATE_PLAYER = 'FAIL_MXI_UPDATE_PLAYER';

export const updatePlayer = (championshipPlayerId, payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_MXI_UPDATE_PLAYER, payload, scope});

    fetch(getMXIEndpoint('updateMXIPlayer', {championshipPlayerId}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_MXI_UPDATE_PLAYER,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayer(data, payload, scope));
      })
      .catch((error, type = FAIL_MXI_UPDATE_PLAYER) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayer(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_MXI_UPDATE_PLAYER,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}


// WEBPACK FOOTER //
// ./src/actions/entities/mxi/updatePlayer.js